import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Colony;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Colony.Phaser.IntroductionScene",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/ColonyGame/scenes/GameIntro.ts